import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

// G2 — Tıklanabilir, sıralanabilir tablo başlığı.
export function SortTh({ label, sortKey, k, dir, onSort, align = "left", className = "", testid }) {
  const active = sortKey === k;
  const Icon = !active ? ChevronsUpDown : dir === "asc" ? ChevronUp : ChevronDown;
  return (
    <th className={`px-4 py-3 font-medium ${align === "right" ? "text-right" : "text-left"} ${className}`}>
      <button
        type="button"
        data-testid={testid || `sort-${k}`}
        onClick={() => onSort(k)}
        className={`inline-flex items-center gap-1 transition-colors hover:text-slate-800 ${active ? "text-brand-green" : ""} ${align === "right" ? "flex-row-reverse" : ""}`}
      >
        {label} <Icon className="h-3.5 w-3.5 opacity-70" />
      </button>
    </th>
  );
}
